<div *ngIf="isLoading">
  <div id="preloader">
    <div id="loader" class="loader">
      <div class="loader-container">
        <div class="loader-icon">
          <img
            [src]="portalConfig?.portalLogoUrl || '../assets/img/logo/logo.png'"
            alt="Preloader"
            class="preloader-logo"
          />
        </div>
      </div>
    </div>
  </div>
</div>
